
export default class ArmourAPI {

	static endpoint = 'https://api.armour.construction';
	static sessionKey = 'arm_session';

	static async newSession(email, password) {
		const response = await fetch(`${this.endpoint}/auth/sign-in`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email, password }),
		});

		if (!response.ok) {
			throw new Error('Failed to create session');
		}

		const { token, expires_at } = await response.json();
		return { token, expires_at };
	}

}
